import { GridCellProps } from "@progress/kendo-react-grid";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { RootState } from "../../../store";
import { useAppSelector } from "../../../store/hooks";

export const DropDownCell: React.FC<GridCellProps> = (props: GridCellProps) => {
  const { dataItem, field, onChange } = props;
  const { landlordFields, cropTypes } = useAppSelector(
    (state: RootState) => state.billingEntity
  );

  const handleChange = (event: DropDownListChangeEvent) => {
    if (onChange) {
      onChange({
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: event.syntheticEvent,
        value: event.value,
        dataIndex: 0,
      });
    }
  };
  
  if (props.field === "cropType") {
    return (
      <td>
        <DropDownList
          data={cropTypes}
          dataItemKey="id"
          textField="name"
          defaultValue={null}
          value={field ? (dataItem[field]?.id ? dataItem[field] : null) : null}
          onChange={handleChange}
        />
      </td>
    );
  } else {
    return (
      <td>
        <DropDownList
          data={landlordFields}
          dataItemKey="id"
          textField="name"
          defaultValue={null}
          value={field ? (dataItem[field]?.id ? dataItem[field] : null) : null}
          onChange={handleChange}
        />
      </td>
    );
  }
};
